export default {
    methods: {
        getOptionsWithEmptySlot(items, selectedValue, label = 'text', value = 'value') {
            if (Array.isArray(items)
                && selectedValue !== null
                && selectedValue !== ''
                && selectedValue !== undefined
            ) {
                return [{[label]: '———', [value]: null}, ...items];
            }

            return items;
        },
    }
};
